import React from "react";
import { TabsPanelProps } from "./tabs-panel.props";
import { useTabsPanelStyles } from "./tabs-panel.styles";

export const TabsPanel = (props: TabsPanelProps) => {
  const classes = useTabsPanelStyles();

  const isHidden = props.value !== props.index;

  return (
    <div
      role="tabpanel"
      className={classes.panel}
      hidden={isHidden}
      id={`simple-tabpanel-${props.index}`}
      aria-labelledby={`simple-tab-${props.index}`}
    >
      {!isHidden && props.children}
    </div>
  );
};
